module.exports = __webpack_public_path__ + "img/scene-bg-1.6be85012.png";